/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import LTButtonBar from './LTButtonBar';
import LTDrawer from './LTDrawer';

export default function LTContainer(): Element<string> {
  return (
    <div
      data-testid="LT"
      className="h-100 LeftToolbar-container LTContainer"
      css={css(`
        z-index: 1008;
        .text-uppercase { text-transform: uppercase; }
        .user-select-none { user-select: none !important; }
        .border-light-white { border-color: #6c757d !important; }
      `)}
    >
      <LTButtonBar />
      <LTDrawer />
    </div>
  );
}
